<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    SMS - Catcher
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <v-btn color="primary" class="ml-auto">
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              clearable
              @click:append="searchRecord"
              @keydown.enter.prevent="searchRecord"
              @click:clear="getList"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :page="table.page"
            :pageCount="table.numberOfPages"
            :options.sync="options"
            :server-items-length="table.total"
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            loading-text="Loading... Please wait"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [10, 50, 100, 250, 500],
            }"
          >
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import ShareableMethods from "../../mixins/ShareableMethods";
export default {
  components: {},
  mixins: [ShareableMethods],
  data() {
    return {
      exportData: [],
      fileName: "",

      search: "",

      table: {
        page: 0,
        total: 0,
        numberOfPages: 0,

        // sortBy: "dtCreated",
        // sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Mobil Number",
            align: "start",
            value: "mobileNumber",
          },
          {
            text: "Message",
            align: "start",
            value: "message",
          },
          {
            text: "Created Date",
            align: "start",
            sortable: true,
            value: "createdAt",
            formatter: (x) =>
              x ? moment(x).format("MMM DD, YYYY hh:mm:ss A") : null,
          },
        ],
        data: [],
      },
      options: {
        page: 1,
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList(searchVal = "") {
      this.table.loading = true;
      await this.$pds
        .get(`/sms?searchVal=${searchVal}`)
        .then((response) => {
          this.table.loading = false;
          const newArr = response.data.data;

          this.table.total = newArr.totalCount;
          this.table.numberOfPages = newArr.totalPages;
          this.table.data = newArr.list;
          this.exportExcel(newArr.list);
          //  this.summaryReports=newArr.summaryReports;
          //  console.log(this.summaryReports);
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },
    searchRecord() {
      this.options.page = 1;
      if (!this.search) {
        return;
      }

      this.getList(this.search);
    },

    exportExcel(items) {
      let exportData = items.map((item) => {
        return {
          "Mobile Number": item.mobileNumber,
          Message: item.message,
          "Created Date / Time": this.formatDate(
            item.createdAt,
            "MMM DD, YYYY hh:mm:ss A"
          ),
        };
      });
      this.fileName = `SMS_LIST`;
      this.exportData = exportData;
    },
  },
  created() {
    // console.log(this.$props.headers);
  },

  mounted() {
    // this.getList();
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },

    options: {
      handler() {
        this.getList(this.search);
      },
      deep: true,
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
